'use strict';

/**
 * @ngdoc function
 * @name thothApp.controller:EmployeeServiceCtrl
 * @description
 * # EmployeeCtrl
 * Controller of the thothApp
 */
angular.module('thothApp.services')
  .factory('Employee', ['$http', 'domain', 'BaseService', 'toaster', function ($http, domain, BaseService, toaster) {
    var BASE_EMPLOYEE_URL = domain.name + '/api/v1/employees/';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_EMPLOYEE_URL,
      baseModelName: 'employee'
    });

    baseService.error = function(error) {
      if(error && error.status === 422) {
        if(error.data.errors) {
          toaster.pop('error', 'Error', error.data.errors);
        }
        if('name' in error.data.errors) {
          toaster.pop('error', 'Nombre', 'El nombre del empleado ' + error.data.errors.name);
        }
        if('employee_code' in error.data.errors) {
          // jscs:disable
          toaster.pop('error', 'Código de Empleado', 'El código de empleado ' + error.data.errors.employee_code);
          // jscs:enable
        }
        if('user_id' in error.data.errors) {
          toaster.pop('error', 'Usuario', 'El usuario ' + error.data.errors.user_id);
        }
      }
      baseService.baseError(error);
    };

    return baseService;
  }]);
